// styles.ts
import { classnames } from '@tailwindcss-classnames';

const baseNavItem = classnames('px-2', 'py-2', 'rounded-md', 'col-span-1');

export const navItem = classnames(
  baseNavItem,
  'font-normal',
  'bg-nzxt-light-grey-100',
  'dark:bg-nzxt-dark-grey-200',
  'first:rounded-r-none',
  'first:rounded-l-md',
  'rounded-l-none'
);

const activeNavItem = classnames(
  'bg-white',
  'dark:bg-nzxt-dark-grey-700',
  'shadow-activeBorderDefault',
  'dark:shadow-activeBorderInverse',
  'border-transparent',
  'font-semibold',
  'z-10'
);

export const isActiveNavItem = (isActive: boolean): string =>
  classnames(baseNavItem, { [activeNavItem]: isActive });

export const navItemLabel = classnames('block');

export const navItemSublabel = classnames(
  'text-nzxt-light-grey-600',
  'dark:text-nzxt-dark-grey-200',
  'text-xs',
  'font-normal',
  'block'
);

export const navWrapper = classnames('w-full', 'mb-6');

export const nav = classnames(
  'grid',
  'grid-cols-2',
  'text-center',
  'bg-nzxt-light-grey-100',
  'dark:bg-nzxt-dark-grey-500',
  'rounded-t-md',
  'relative',
  'z-10'
);

export const servicesWrapper = classnames(
  'bg-nzxt-light-grey-50',
  'dark:bg-nzxt-dark-grey-600',
  'pt-8',
  'px-6',
  'pb-6',
  'rounded-b-md',
  '-mt-2',
  'space-y-2'
);
